document.addEventListener("DOMContentLoaded", () => {
    
    const mobileSearch = () => {
        const searchBtn = document.querySelector('.td-mobile-drawer__search');
        const searchFormWrapper = document.querySelector('.td-mobile-drawer__mobile-search')
        if(searchBtn && searchFormWrapper) {
            searchBtn.addEventListener('click', (e) => {
                e.preventDefault()
                searchFormWrapper.classList.toggle('display-search')                
            })
        }
    }
    const megaMenu = () => {
        const details = Array.from(document.querySelectorAll("details.mega-menu"))
        if(details.length){
          details.map(elem => {
            elem.addEventListener("toggle", function() {            
              let content = this.querySelector(".mega-menu__content");   
              if(content) {
                content.classList.toggle('display-menu')
                content.classList.toggle('fade-in')
              }       
             
            
            });
          })                   
            
          }      
      }
   
    mobileSearch()
    megaMenu()
});